
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { IMPRESSUM_TEXT, DATENSCHUTZ_TEXT } from '@/lib/legalContent';

export function LegalModal({ triggerText, type }) {
  const content = type === 'impressum' ? IMPRESSUM_TEXT : DATENSCHUTZ_TEXT;
  const title = type === 'impressum' ? 'Impressum' : 'Datenschutz';

  // Simple markdown-like parser for bolding and headings
  const renderContent = (text) => {
    return text.split('\n').map((line, i) => {
      if (line.startsWith('# ')) return <h1 key={i} className="text-2xl font-bold mt-4 mb-2 text-emerald-900">{line.replace('# ', '')}</h1>;
      if (line.startsWith('## ')) return <h2 key={i} className="text-xl font-bold mt-3 mb-1 text-emerald-800">{line.replace('## ', '')}</h2>;
      if (line.startsWith('**')) return <p key={i} className="font-bold my-1">{line.replace(/\*\*/g, '')}</p>;
      return <p key={i} className="my-1 text-stone-700 leading-relaxed">{line}</p>;
    });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="hover:text-emerald-400 transition-colors text-left">{triggerText}</button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl h-[80vh] bg-white border border-stone-200">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-emerald-900">{title}</DialogTitle>
          <DialogDescription>
             Rechtliche Informationen der Waldhotel Bad Essen UG
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-full pr-4">
          <div className="text-sm">
            {renderContent(content)}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
